@if (type == 'default') {
  <div>
    <div class="d-flex justify-content-space-between mbm">
      @for (step of steps; track step) {
        <span>
          {{ step }}
        </span>
      }
    </div>
    <div class="pr-progress-cursor-bar">
      <div
        class="cursor"
        [style.right.%]="currentValue <= 5 ? currentValue * 20 : 100"
      ></div>
    </div>
  </div>
}

@if (type == 'risk') {
  <div class="risk">
    <div class="d-flex justify-content-space-between steps">
      @for (step of steps; track step) {
        <span>
          {{ step }}
        </span>
      }
    </div>
    <div [class]="'pr-progress-cursor-bar ' + (!currentValue ? 'no-lg' : '')">
      @if (currentValue) {
        <div class="cursor" [style.left.%]="calculateCursorPosition()"></div>
      }
      @if (currentValue) {
        <div class="val" [style.left.%]="calculateCursorPosition() - 1">
          {{ currentValue }}
        </div>
      }
    </div>
  </div>
}
